import React from 'react';
import PropTypes from 'prop-types';
import VenueCard from './VenueCard';
import './VenuesGrid.scss';

const VenuesGrid = ({
  venues, bookNowLinkText, noBookNowText, handleDirTagging,
}) => (
  <div className="GDA__Venues__Wrap">
    <div className="GDA__Venues__Wrap__Grid">
      {
        venues.map((venue) => (
          <VenueCard
            key={`${venue.city_code}-${venue.name}`}
            venue={venue}
            bookNowLinkText={bookNowLinkText}
            noBookNowText={noBookNowText}
            handleDirTagging={handleDirTagging}
          />
        ))
      }
    </div>
  </div>
);

VenuesGrid.defaultProps = {
  venues: [],
  bookNowLinkText: '',
  noBookNowText: '',
};

VenuesGrid.propTypes = {
  bookNowLinkText: PropTypes.string,
  noBookNowText: PropTypes.string,
  venues: PropTypes.arrayOf(PropTypes.object),
  handleDirTagging: PropTypes.func.isRequired,
};

export default VenuesGrid;
